import * as yup from "yup";
import { LocalizationService } from "@progress/kendo-react-intl";
import { enMessages } from "../../../messages/en-US";

export default function adminDeviceValidationSchema(localizationService: LocalizationService, devices: any[] = []) {
  return yup.object().shape({
    siteId: yup
      .string()
      .required(`${localizationService.toLanguageString('custom.selectAccountId', enMessages.custom.selectAccountId)}`),
    serialNumber: yup
      .string()
      .required(`${localizationService.toLanguageString('custom.fieldIsRequired', enMessages.custom.fieldIsRequired)}`)
      .test(
        'unique-serial',
        `${localizationService.toLanguageString('custom.serialNumberExists', enMessages.custom.uniqueSerialNumber)}`,
        function(value) {
          if (!value) return true;
          return !devices.some(
            device => device.serialNumber && device.serialNumber.toLowerCase() === value.toLowerCase()
          );
        }
      ),
    inactivityTimeoutInMinutes: yup
      .number()
      .required(`${localizationService.toLanguageString('custom.fieldIsRequired', enMessages.custom.fieldIsRequired)}`)
  });
}
